(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1255],{

/***/ 49882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_CustomizationInfoDialog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/lib/modal/Modal.js
var Modal = __webpack_require__(83663);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/Common/CustomizationDialog.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 0px;\n  }\n\n  .ant-modal-content {\n    border-radius: 12px;\n  }\n  .ant-modal-header {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-dd22d55e-0"
})(_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var Body = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-dd22d55e-1"
})(_templateObject1(), globals/* color.charcoal10 */.$.charcoal10);
var BodyCenter = (0,styled_components_browser_esm/* default */.ZP)(Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-dd22d55e-2"
})(_templateObject2());
var CustomizationDialog_styled_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    fullWidth: true
}).withConfig({
    componentId: "sc-dd22d55e-3"
})(_templateObject3());
var CustomizationDialog_styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal["default"]).withConfig({
    componentId: "sc-dd22d55e-4"
})(_templateObject4());
var CustomizationDialogContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dd22d55e-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/Common/CustomizationInfoDialog.tsx








var styles = {
    buttonGroup: {
        marginTop: "16px"
    },
    button: {
        margin: "4px 0px"
    }
};
var CustomizationInfoDialog = function(_param) {
    var title = _param.title, body = _param.body, _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, onConfirm = _param.onConfirm, isLoading = _param.isLoading, _confirmText = _param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, image = _param.image, width = _param.width, centered = _param.centered, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "body",
        "isVisible",
        "onConfirm",
        "isLoading",
        "confirmText",
        "image",
        "width",
        "centered"
    ]);
    var sm = (0,useBreakpoint/* default */.Z)().sm;
    var modalWidth = width || (sm ? "502px" : "auto");
    var bodyComponent = /*#__PURE__*/ (0,react.isValidElement)(body) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
        children: body
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyCenter, {
        children: body
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomizationDialog_styled_Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        centered: centered,
        width: modalWidth,
        visible: isVisible,
        footer: null,
        closable: false,
        "data-testid": "info-dialog-modal",
        "data-gtm-input-code": "info-dialog-modal"
    }, props), {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomizationDialogContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    bodyComponent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        justify: "center",
                        style: styles.buttonGroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizationDialog_styled_Button, {
                                "data-testid": "info-dialog-confirm-button",
                                "data-gtm-input-code": "info-dialog-confirm-button",
                                onClick: onConfirm,
                                loading: isLoading,
                                style: styles.button,
                                children: confirmText
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Common_CustomizationInfoDialog = (CustomizationInfoDialog);


/***/ }),

/***/ 6153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var EmailIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "mail filled",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Subtract",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.00048 6.96878C2.00016 6.97915 2 6.98956 2 7V25C2 25.5523 2.44771 26 3 26H29C29.5523 26 30 25.5523 30 25V7C30 6.98957 29.9998 6.97917 29.9995 6.96882L16.6402 18.1016C16.2693 18.4106 15.7307 18.4106 15.3598 18.1016L2.00048 6.96878ZM28.038 6H3.96204L16 16.0317L28.038 6Z",
                    fill: "currentColor"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmailIcon);


/***/ }),

/***/ 897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var LineIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Frame",
                    clipPath: "url(#clip0_2095_267546)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            id: "Rectangle 1",
                            x: "5.83594",
                            y: "6.66699",
                            width: "21.3333",
                            height: "13.3333",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            id: "Group",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Vector",
                                d: "M32.4279 12.3459L32.4106 12.2572L32.3761 11.9379C32.3761 11.867 32.3588 11.796 32.3588 11.7251V11.6541H32.3415C31.9441 9.36585 30.8728 7.21951 29.2141 5.35698C27.5554 3.51219 25.4128 2.07539 23.0111 1.15299C20.9376 0.390244 18.7433 0 16.4798 0C13.4387 0 10.4841 0.727273 7.92684 2.1286C3.00243 4.8071 0.1169 9.73836 0.531587 14.6874C0.756209 17.2417 1.72381 19.6896 3.36528 21.7295C4.90308 23.663 6.97651 25.2239 9.36096 26.235C10.8296 26.8559 12.281 27.1574 13.8188 27.459L13.9916 27.4945C14.4063 27.5831 14.5273 27.7073 14.5618 27.7428C14.6137 27.8315 14.5791 28.0089 14.5618 28.0976C14.5445 28.204 14.5273 28.2927 14.51 28.3814C14.3372 29.0732 14.1817 29.7827 14.3026 30.5809C14.4582 31.4856 15.0111 32 15.8059 32C16.6698 32 17.6547 31.3969 18.3113 31.0067L18.3977 30.9534C19.9528 30.0133 21.4214 28.949 22.5273 28.133C24.9463 26.3415 27.6763 24.3193 29.7325 21.694C31.8232 19.051 32.7908 15.6452 32.4279 12.3459ZM10.4668 17.3659H7.70221C7.28753 17.3659 6.94195 17.0111 6.94195 16.5854V10.643C6.94195 10.2173 7.28753 9.86253 7.70221 9.86253C8.1169 9.86253 8.46247 10.2173 8.46247 10.643V15.8226H10.4668C10.8815 15.8226 11.2271 16.1774 11.2271 16.6031C11.2271 17.0111 10.8815 17.3659 10.4668 17.3659ZM13.3523 16.5676C13.3523 16.9933 13.0068 17.3481 12.5921 17.3481C12.1774 17.3481 11.8318 16.9933 11.8318 16.5676V10.6075C11.8318 10.1818 12.1774 9.82705 12.5921 9.82705C13.0068 9.82705 13.3523 10.1818 13.3523 10.6075V16.5676ZM20.1774 16.5676C20.1774 16.9047 19.97 17.2062 19.659 17.3126C19.5726 17.3304 19.5035 17.3481 19.4171 17.3481C19.1752 17.3481 18.9506 17.2417 18.8124 17.0288L16.0823 13.1796V16.5676C16.0823 16.9933 15.7368 17.3481 15.3221 17.3481C14.9074 17.3481 14.5618 16.9933 14.5618 16.5676V10.7849C14.5618 10.4479 14.7692 10.1463 15.0802 10.0399C15.3912 9.93348 15.7368 10.0576 15.9268 10.3237L18.6396 14.1729V10.6075C18.6396 10.1818 18.9852 9.82705 19.3998 9.82705C19.8145 9.82705 20.1601 10.1818 20.1601 10.6075V16.5676H20.1774ZM25.672 17.2239H21.9398C21.5251 17.2239 21.1795 16.8692 21.1795 16.4435V13.4634V10.4834C21.1795 10.0576 21.5251 9.70288 21.9398 9.70288H25.5683C25.983 9.70288 26.3286 10.0576 26.3286 10.4834C26.3286 10.9091 25.983 11.2639 25.5683 11.2639H22.7001V12.6829H25.0327C25.4474 12.6829 25.7929 13.0377 25.7929 13.4634C25.7929 13.8891 25.4474 14.2439 25.0327 14.2439H22.7001V15.663H25.6893C26.1039 15.663 26.4495 16.0177 26.4495 16.4435C26.4495 16.8692 26.1039 17.2239 25.672 17.2239Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_2095_267546",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.5)"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineIcon);


/***/ }),

/***/ 98909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var PhoneIcon = function(param) {
    var width = param.width, height = param.height, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 57 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "phone",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Vector",
                    d: "M51.6634 39.4801V46.4801C51.6661 47.1299 51.5329 47.7731 51.2726 48.3685C51.0123 48.964 50.6304 49.4984 50.1516 49.9377C49.6727 50.3771 49.1074 50.7115 48.4918 50.9197C47.8762 51.1279 47.224 51.2052 46.5767 51.1467C39.3967 50.3666 32.4997 47.9131 26.4401 43.9834C20.8023 40.4009 16.0225 35.6211 12.4401 29.9834C8.4967 23.8962 6.04265 16.9657 5.27675 9.7534C5.21844 9.10815 5.29513 8.45784 5.50192 7.84385C5.70871 7.22987 6.04108 6.66567 6.47787 6.18718C6.91466 5.70869 7.4463 5.32639 8.03893 5.06461C8.63156 4.80284 9.27221 4.66734 9.92009 4.66673H16.9201C18.0525 4.65559 19.1503 5.05658 20.0089 5.79497C20.8675 6.53337 21.4283 7.55877 21.5868 8.68006C21.8822 10.9202 22.4301 13.1198 23.2201 15.2367C23.534 16.0719 23.602 16.9795 23.4159 17.8521C23.2298 18.7247 22.7974 19.5257 22.1701 20.1601L19.2068 23.1234C22.5284 28.965 27.3651 33.8018 33.2068 37.1234L36.1701 34.1601C36.8045 33.5327 37.6054 33.1004 38.478 32.9143C39.3506 32.7282 40.2583 32.7961 41.0934 33.1101C43.2104 33.9 45.4099 34.4479 47.6501 34.7434C48.7835 34.9033 49.8187 35.4742 50.5587 36.3476C51.2986 37.2209 51.6918 38.3357 51.6634 39.4801Z",
                    fill: color !== null && color !== void 0 ? color : "currentColor"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneIcon);


/***/ }),

/***/ 24899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86501);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60082);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);




/**
 * Renders a toast notification with the copied message.
 * @example
 * ```tsx
 * const onWriteClipboard = () => {
 *  navigator.clipboard.writeText(orderId);
 *  Toast(text:string); // <<-- renders the toast
 * };
 *
 * ```
 *
 * @return {JSX.Element} The rendered toast notification.
 */ var Toast = function(text) {
    return (0,react_hot_toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Body, {
        level: 7,
        style: {
            color: src_styles_globals__WEBPACK_IMPORTED_MODULE_3__/* .color.white */ .$.white
        },
        children: text
    }), {
        position: "bottom-center",
        style: {
            borderRadius: "12px",
            backgroundColor: src_styles_globals__WEBPACK_IMPORTED_MODULE_3__/* .color.charcoal10 */ .$.charcoal10,
            padding: "12px"
        },
        duration: 2000
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Toast);


/***/ }),

/***/ 68814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ withUserProfileLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/breadcrumb/index.js + 3 modules
var breadcrumb = __webpack_require__(58492);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./src/utils/url.ts
var utils_url = __webpack_require__(65934);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/userProfile.ts
var userProfile = __webpack_require__(763);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./src/utils/maskData.ts
var maskData = __webpack_require__(65791);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./src/api/auth.ts
var auth = __webpack_require__(36707);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
;// CONCATENATED MODULE: ./src/components/Common/Icons/BulletListIcon.tsx

var BulletListIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 6H21",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 12H21",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 18H21",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 6H3.01",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 12H3.01",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 18H3.01",
                    stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_BulletListIcon = (BulletListIcon);

;// CONCATENATED MODULE: ./src/components/Common/Icons/SettingIcon.tsx


var SettingIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip0_4026_163700)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                            stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                            strokeWidth: "1.33",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z",
                            stroke: color !== null && color !== void 0 ? color : "#2A2C2E",
                            strokeWidth: "1.33",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_4026_163700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 3 modules
var menu = __webpack_require__(38792);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/User/style/UserMenu.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-wrap: balance;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  .ant-menu-item {\n    height: auto;\n    margin: 0px !important;\n    padding: 16px !important;\n    column-gap: 8px;\n  }\n  .ant-menu-item-selected,\n  .ant-menu-item:active {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n  .ant-menu-item:after {\n    border-right: unset !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  .ant-menu-title-content .title {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: none;\n  column-gap: ",
        "!important;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var ProfileName = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 6
}).withConfig({
    componentId: "sc-721334fa-0"
})(_templateObject());
var CustomMenu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z).withConfig({
    componentId: "sc-721334fa-1"
})(_templateObject1(), globals/* color.carrotOrange */.$.carrotOrange, globals/* color.charcoal03 */.$.charcoal03);
var MainMenuItem = (0,styled_components_browser_esm/* default */.ZP)(menu/* default.Item */.Z.Item).withConfig({
    componentId: "sc-721334fa-2"
})(_templateObject2(), globals/* color.charcoal03 */.$.charcoal03, globals/* color.charcoal03 */.$.charcoal03, function(props) {
    return props.selected ? globals/* color.carrotOrange */.$.carrotOrange : globals/* color.charcoal10 */.$.charcoal10;
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7,
    className: "title"
}).withConfig({
    componentId: "sc-721334fa-3"
})(_templateObject3());
var LogoutTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-721334fa-4"
})(_templateObject4(), globals/* color.errorRed02 */.$.errorRed02);
var ProfileMenuItem = (0,styled_components_browser_esm/* default */.ZP)(menu/* default.Item */.Z.Item).withConfig({
    componentId: "sc-721334fa-5"
})(_templateObject5(), function(props) {
    return props.columnGap || "8px";
});

;// CONCATENATED MODULE: ./src/components/Common/Icons/AffiliateIcon.tsx

var AffiliateIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height, _color = param.color, color = _color === void 0 ? "#2A2C2E" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    stroke: color,
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.6125 11.7337C14.5388 11.7712 15.0712 12.165 15.3975 12.7125C15.5662 12.9975 15.66 13.3762 15.66 13.8075C15.66 14.2387 15.57 14.64 15.3863 14.955C14.97 15.6975 14.0812 16.1287 12.8175 16.1663V17.2087H11.3588V16.1663H9V7.0425H11.3588V6H12.8175V7.0425C14.0812 7.08 14.97 7.51125 15.3863 8.25375C15.57 8.565 15.66 8.95875 15.66 9.40125C15.66 9.84375 15.57 10.2112 15.3975 10.4963C15.0862 11.0437 14.5125 11.4225 13.6125 11.46V11.7337ZM13.4588 9.8025C13.4588 9.5925 13.4212 9.42375 13.3425 9.28125C13.1588 8.9925 12.8213 8.865 12.3263 8.865H11.0625V10.755H12.3263C12.8213 10.755 13.1588 10.6125 13.3425 10.3125C13.4212 10.17 13.4588 10.0125 13.4588 9.8025ZM13.4588 13.4025C13.4588 13.1925 13.4212 13.0388 13.3425 12.8925C13.1588 12.5925 12.8213 12.45 12.3263 12.45H11.0625V14.34H12.3263C12.8213 14.34 13.1588 14.2088 13.3425 13.9238C13.4212 13.7813 13.4588 13.6125 13.4588 13.4025Z",
                    fill: color
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_AffiliateIcon = (AffiliateIcon);

;// CONCATENATED MODULE: ./src/components/User/UserMenu.tsx




















var renderIcon = function(menu, isSelected) {
    if (typeof menu.icon === "string") return menu.icon;
    return /*#__PURE__*/ react.cloneElement(menu.icon, {
        color: isSelected ? globals/* color.carrotOrange */.$.carrotOrange : globals/* color.charcoal10 */.$.charcoal10
    });
};
var UserProfileMenu = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)("user-profile").t;
    var user = props.user;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, asPath = ref.asPath, push = ref.push, query = ref.query, reload = ref.reload;
    var selectedMenu = asPath.split("/").pop().split("?")[0];
    var authUrl = "https://auth.easysunday.com";
    var menus = (0,react.useMemo)(function() {
        return [
            {
                key: "orders",
                type: userProfile/* USER_MENU_TYPE.MAIN */.Jo.MAIN,
                title: {
                    th: "ดูสถานะคำสั่งซื้อ",
                    en: "View order status"
                },
                onClick: function() {
                    push({
                        pathname: "/user/orders",
                        query: (0,utils_url/* filterParams */.Lt)(query, params/* GLOBAL_PARAMS */.g_)
                    });
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BulletListIcon, {})
            },
            {
                key: "affiliate",
                type: userProfile/* USER_MENU_TYPE.MAIN */.Jo.MAIN,
                title: {
                    th: "Sunday Affiliate Program",
                    en: "Sunday Affiliate Program"
                },
                onClick: function() {
                    push({
                        pathname: "/affiliate",
                        query: (0,utils_url/* filterParams */.Lt)(query, params/* GLOBAL_PARAMS */.g_)
                    });
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AffiliateIcon, {})
            },
            {
                key: "setting",
                type: userProfile/* USER_MENU_TYPE.MAIN */.Jo.MAIN,
                title: {
                    th: "ตั้งค่าบัญชีผู้ใช้",
                    en: "Account settings"
                },
                onClick: function() {
                    window.open("".concat(authUrl, "/").concat(locale, "/setting/profile-info"), "_blank");
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingIcon, {}),
                hide: true
            },
            {
                key: "logout",
                type: userProfile/* USER_MENU_TYPE.LOGOUT */.Jo.LOGOUT,
                title: {
                    th: "ออกจากระบบ",
                    en: "Logout"
                },
                onClick: function() {},
                icon: "/static/pages/userProfile/log-out.svg",
                hide: true
            }, 
        ];
    }, [
        authUrl,
        locale,
        push,
        query
    ]);
    var mainSection = menus.filter(function(menu) {
        return menu.type === userProfile/* USER_MENU_TYPE.MAIN */.Jo.MAIN;
    });
    var logoutMenu = menus.find(function(menu) {
        return menu.type === userProfile/* USER_MENU_TYPE.LOGOUT */.Jo.LOGOUT;
    });
    var mobileNo = (0,format/* formatMobileNumberToInternal */.jS)(user === null || user === void 0 ? void 0 : user.profile.contacts.primaryphone);
    var handleLogOut = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,auth/* logout */.kS)()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        (0,logger/* logError */.H)("[profile-header] fail on logout", error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogOut() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomMenu, {
        mode: "inline",
        defaultSelectedKeys: [
            "1"
        ],
        selectable: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileMenuItem, {
                disabled: true,
                columnGap: "16px",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/static/profile-menu-default-user-icon.svg",
                    height: 32,
                    width: 32
                }),
                children: [
                    (user === null || user === void 0 ? void 0 : user.profile.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileName, {
                        children: user === null || user === void 0 ? void 0 : user.profile.name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileName, {
                        children: t("defaultProfileName")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                        level: 7,
                        children: (0,maskData/* maskProfilePhoneNumber */.hA)(mobileNo)
                    })
                ]
            }, "user-profile-menu-user"),
            mainSection.map(function(menu) {
                var isSelected = menu.key === selectedMenu;
                if (menu.hide) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuItem, {
                    selected: isSelected,
                    icon: renderIcon(menu, isSelected),
                    onClick: function() {
                        return menu.onClick();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        level: 7,
                        children: menu.title[locale]
                    })
                }, "user-profile-menu-".concat(menu.key));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuItem, {
                selected: false,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 24,
                    height: 24,
                    src: logoutMenu.icon
                }),
                onClick: handleLogOut,
                hidden: logoutMenu.hide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutTitle, {
                    level: 7,
                    children: logoutMenu.title[locale]
                })
            }, "user-profile-logout")
        ]
    });
};
/* harmony default export */ var UserMenu = (UserProfileMenu);

// EXTERNAL MODULE: ./node_modules/antd/es/layout/index.js
var layout = __webpack_require__(97183);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
;// CONCATENATED MODULE: ./src/components/Layout/style/UserProfileLayout.style.tsx

function UserProfileLayout_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  min-height: 66.67vh; // follow min-height of withLayout CustomContent\n  padding: 40px;\n  ",
        " {\n    padding: 0px;\n    margin: 0px;\n    height: fit-content;\n    min-height: fit-content;\n  }\n"
    ]);
    UserProfileLayout_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserProfileLayout_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: ",
        ";\n  margin: 0 auto;\n  padding-bottom: 80px;\n  max-width: 1192px;\n  background: none;\n  column-gap: 32px;\n  ",
        " {\n    padding: 0px;\n    height: fit-content;\n  }\n"
    ]);
    UserProfileLayout_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserProfileLayout_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  max-width: 886px;\n  width: 100%;\n  height: fit-content;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n  ",
        " {\n    padding: ",
        ";\n    margin: 0px;\n    border-radius: 0px;\n    border: none;\n    max-width: 100%;\n    min-height: 600px;\n  }\n"
    ]);
    UserProfileLayout_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserProfileLayout_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  overflow: hidden;\n  height: fit-content;\n  width: 100% !important;\n  max-width: 275px !important;\n  flex: auto !important;\n"
    ]);
    UserProfileLayout_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UserProfileLayout_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding-bottom: 40px;\n  max-width: 886px;\n  width: 100%;\n  display: flex;\n  span {\n    display: flex;\n  }\n  span .ant-breadcrumb-link > div > a:hover {\n    color: ",
        ";\n  }\n  span:last-child {\n    pointer-events: none;\n  }\n  span:last-child .ant-breadcrumb-link > div {\n    font-weight: bold;\n  }\n  ",
        " {\n    margin: 0px;\n    padding: 16px 24px;\n  }\n"
    ]);
    UserProfileLayout_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UserProfileLayout_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: ",
        ";\n  display: flex;\n  width: fit-content;\n  column-gap: 4px;\n  div {\n    font-weight: bold;\n  }\n"
    ]);
    UserProfileLayout_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: auto;\n  padding: 16px 24px;\n  max-width: 886px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Content = layout/* default.Content */.Z.Content, Sider = layout/* default.Sider */.Z.Sider;
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38056fbb-0"
})(UserProfileLayout_style_templateObject(), globals/* color.charcoal01 */.$.charcoal01, (0,styled_breakpoints.down)("md"));
var CustomLayout = (0,styled_components_browser_esm/* default */.ZP)(layout/* default */.Z).withConfig({
    componentId: "sc-38056fbb-1"
})(UserProfileLayout_style_templateObject1(), function(props) {
    return props.hideSidebar ? "center" : "flex-start";
}, (0,styled_breakpoints.down)("md"));
var CustomContent = (0,styled_components_browser_esm/* default */.ZP)(Content).withConfig({
    componentId: "sc-38056fbb-2"
})(UserProfileLayout_style_templateObject2(), function(props) {
    return props.padding || "24px";
}, globals/* color.white */.$.white, globals/* color.charcoal03 */.$.charcoal03, (0,styled_breakpoints.down)("md"), function(props) {
    return props.padding || "16px";
});
var CustomSider = (0,styled_components_browser_esm/* default */.ZP)(Sider).withConfig({
    componentId: "sc-38056fbb-3"
})(UserProfileLayout_style_templateObject3(), globals/* color.charcoal03 */.$.charcoal03);
var StyledBreadcrumb = (0,styled_components_browser_esm/* default */.ZP)(breadcrumb/* default */.Z).withConfig({
    componentId: "sc-38056fbb-4"
})(UserProfileLayout_style_templateObject4(), globals/* color.carrotOrange */.$.carrotOrange, (0,styled_breakpoints.down)("md"));
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-38056fbb-5"
})(UserProfileLayout_style_templateObject5(), globals/* color.charcoal10 */.$.charcoal10);
var PrevButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38056fbb-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/Layout/withUserProfileLayout.tsx













/**
 * Renders a custom breadcrumb component based on the current URL path and the provided breadcrumbNameMap.
 */ var CustomBreadcrumb = function(param) {
    var breadcrumbName = param.breadcrumbName;
    var ref = (0,next_router.useRouter)(), asPath = ref.asPath, query = ref.query;
    var filteredParams = (0,utils_url/* filterParams */.Lt)(query);
    var ref1 = (0,useBreakpoint/* default */.Z)(), md = ref1.md, xs = ref1.xs;
    var pathSnippets = asPath.split("/").map(function(p) {
        return p.split("?")[0];
    }) // remove query string
    .filter(function(path) {
        return path !== "" && path !== "user";
    }); // remove empty string and "user"
    var extraBreadcrumbItems = pathSnippets.map(function(path, index) {
        if (!path) return null;
        var url = "/".concat(pathSnippets.slice(0, index + 1).join("/"));
        var queryParams = Object.keys(filteredParams).length > 0 ? "?".concat((0,qs_lib.stringify)(filteredParams)) : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
            separator: ">",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                level: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "/user".concat(url).concat(queryParams),
                    children: breadcrumbName[url]
                })
            })
        }, url);
    });
    if (md && extraBreadcrumbItems.length > 2 || xs) {
        var url = "/".concat(pathSnippets.slice(0, -1).join("/"));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                href: "/user".concat(url),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/static/arrow-left-icon.svg",
                        width: 16,
                        height: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                        level: 7,
                        children: breadcrumbName[url]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBreadcrumb, {
        separator: ">",
        children: extraBreadcrumbItems
    });
};
var withUserProfileLayout = function(WrappedComponent) {
    return function(props) {
        var breadcrumb = props.breadcrumb, hideSidebar = props.hideSidebar, contentPadding = props.contentPadding, user = props.user;
        var t = (0,useTranslation/* useTranslation */.$)("user-profile").t;
        var router = (0,next_router.useRouter)();
        var locale = router.locale;
        var lg = (0,useBreakpoint/* default */.Z)().lg;
        var shouldHideSidebar = hideSidebar || !user;
        var breadcrumbNameMap = {
            "/setting": t("setting.title"),
            "/setting/personal-info": t("editPersonalInfo.title")
        };
        // Dev-note: to prevent /default/404, /default/500 pre-render error on build time
        if (locale === "default") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLayout, {
                    hideSidebar: shouldHideSidebar,
                    children: [
                        lg && !shouldHideSidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSider, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenu, {
                                user: user
                            })
                        }) : null,
                        breadcrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadcrumb, {
                            breadcrumbName: breadcrumbNameMap
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                            padding: contentPadding,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
                        })
                    ]
                })
            ]
        });
    };
};


/***/ }),

/***/ 32:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_ContactModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
// EXTERNAL MODULE: ./src/components/Common/Icons/PhoneIcon.tsx
var PhoneIcon = __webpack_require__(98909);
// EXTERNAL MODULE: ./src/components/Common/Icons/EmailIcon.tsx
var EmailIcon = __webpack_require__(6153);
// EXTERNAL MODULE: ./src/components/Common/Icons/LineIcon.tsx
var LineIcon = __webpack_require__(897);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(35865);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/Modal/style/ContactModal.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  margin: 0px;\n  padding: 0px;\n  max-width: 333px;\n  .ant-modal-content {\n    text-align: center;\n    padding: 0px;\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  .ant-modal-header {\n    padding: 24px 0px;\n    border: none;\n  }\n  .ant-modal-body {\n    padding: 0px 16px;\n    overflow: auto;\n  }\n  .ant-modal-footer {\n    border: none;\n    padding: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--ui-form-button-text-enabled-text-color);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 8px 0px;\n  color: var(--ui-form-button-text-enabled-text-color);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-a04e10ee-0"
})(_templateObject());
var ModalBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-a04e10ee-1"
})(_templateObject1(), globals/* color.charcoal09 */.$.charcoal09);
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-a04e10ee-2"
})(_templateObject2(), globals/* color.charcoal10 */.$.charcoal10);
var ContactLink = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-a04e10ee-3"
})(_templateObject3());
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a04e10ee-4"
})(_templateObject4());
var ContactContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a04e10ee-5"
})(_templateObject5());
var ContactItem = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: 16
}).withConfig({
    componentId: "sc-a04e10ee-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/Modal/ContactModal.tsx










var ContactModal = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onCloseModal = param.onCloseModal, onCloseModal = _onCloseModal === void 0 ? function() {} : _onCloseModal, _contact = param.contact, contact = _contact === void 0 ? {} : _contact;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,useTranslation/* useTranslation */.$)("contact").t;
    var locale = (0,router.useRouter)().locale;
    var handleOnCloseModal = function() {
        onCloseModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
            level: 6,
            style: {
                textAlign: "center"
            },
            children: t("title")
        }),
        closable: false,
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            fullWidth: true,
            onClick: handleOnCloseModal,
            children: t("closeButton")
        }),
        visible: visible,
        onCancel: handleOnCloseModal,
        centered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody, {
                level: 7,
                children: t("subTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* default */.Z, {
                                        width: 32,
                                        height: 32
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                style: {
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 7,
                                        children: (ref = contact.cs) === null || ref === void 0 ? void 0 : ref.title[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (ref1 = contact.cs) === null || ref1 === void 0 ? void 0 : ref1.telLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLink, {
                                            level: 7,
                                            children: (ref2 = contact.cs) === null || ref2 === void 0 ? void 0 : ref2.tel
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                        level: 9,
                                        children: t("mobile.subTitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailIcon/* default */.Z, {
                                        width: 32,
                                        height: 32
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                style: {
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 7,
                                        children: (ref3 = contact.email) === null || ref3 === void 0 ? void 0 : ref3.title[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (ref4 = contact.email) === null || ref4 === void 0 ? void 0 : ref4.emailLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLink, {
                                            level: 7,
                                            children: (ref5 = contact.email) === null || ref5 === void 0 ? void 0 : ref5.email
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                        level: 9,
                                        children: t("email.subTitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineIcon/* default */.Z, {
                                        width: 32,
                                        height: 32
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                style: {
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 7,
                                        children: (ref6 = contact.line) === null || ref6 === void 0 ? void 0 : ref6.title[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (ref7 = contact.line) === null || ref7 === void 0 ? void 0 : ref7.lineIdLink,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLink, {
                                            level: 7,
                                            children: (ref8 = contact.line) === null || ref8 === void 0 ? void 0 : ref8.lineId
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                        level: 9,
                                        children: t("line.subTitle")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Modal_ContactModal = (ContactModal);


/***/ }),

/***/ 71512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ DATE_INPUT_TEXT_FORMAT; },
/* harmony export */   "IG": function() { return /* binding */ DATE_DISPLAY_FORMAT; }
/* harmony export */ });
/* unused harmony exports SALESFORCE_DATE_AND_TIME, DATE_SLASH_FORMAT */
/* eslint-disable import/prefer-default-export */ var DATE_INPUT_TEXT_FORMAT = "YYYY-MM-DD";
var SALESFORCE_DATE_AND_TIME = "YYYY-MM-DD HH:mm:ss";
var DATE_SLASH_FORMAT = "DD/MM/YYYY";
var DATE_DISPLAY_FORMAT = {
    th: "D MMM BBBB",
    en: "D MMM YYYY"
};


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jo": function() { return /* binding */ USER_MENU_TYPE; },
/* harmony export */   "h4": function() { return /* binding */ AFFILIATE_FORM_FIELDS; },
/* harmony export */   "hl": function() { return /* binding */ USER_CONSENT; },
/* harmony export */   "x9": function() { return /* binding */ USER_FORM_FIELDS; }
/* harmony export */ });
/* unused harmony export USER_PROFILE_KEY */
var USER_MENU_TYPE = {
    HEADER: "header",
    MAIN: "main",
    FOOTER: "footer",
    LOGOUT: "logout"
};
var USER_FORM_FIELDS = {
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    GENDER: "gender",
    NATIONALITY: "nationality",
    IDENTITY_NO: "identityNo",
    EMAIL: "email",
    MOBILE_NO: "mobileNo",
    DOB: "dob"
};
var AFFILIATE_FORM_FIELDS = {
    PRIMARY_EMAIL: "PRIMARYEMAIL",
    DOB: "dob",
    EMAIL: "email",
    FIRST_NAME: "firstname",
    LAST_NAME: "lastname"
};
var USER_PROFILE_KEY = {
    NAME: "name",
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    GENDER: "sex",
    DOB: "dob",
    MARITAL_STATUS: "mobileNo",
    IDENTITY: "identities",
    CONSENTS: "consents"
};
var USER_CONSENT = {
    SUNDAY_AFFILIATE: "SUNDAY_AFFILIATE"
};


/***/ }),

/***/ 63049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ ORDER_LIST_DATE_HOUR_MINUTE_FORMAT; },
/* harmony export */   "Do": function() { return /* binding */ formatLocalizedDateText; },
/* harmony export */   "FK": function() { return /* binding */ isAfterDateTime; },
/* harmony export */   "K_": function() { return /* binding */ DEFAULT_DATE_FORMAT; },
/* harmony export */   "Kb": function() { return /* binding */ formatDateText; },
/* harmony export */   "Md": function() { return /* binding */ MOTOR_SUMMARY_DATE_FORMAT; },
/* harmony export */   "f8": function() { return /* binding */ ORDER_LIST_DATE_LONG_FORMAT; },
/* harmony export */   "fT": function() { return /* binding */ isAfterDate; },
/* harmony export */   "gO": function() { return /* binding */ isBeforeDate; },
/* harmony export */   "s5": function() { return /* binding */ DATE_PICKER_DATE_FORMAT; },
/* harmony export */   "sE": function() { return /* binding */ isInDatePeriod; },
/* harmony export */   "z0": function() { return /* binding */ ORDER_LIST_DATE_SHORT_FORMAT; },
/* harmony export */   "zk": function() { return /* binding */ isToday; }
/* harmony export */ });
/* unused harmony exports DATE_LONG_FORMAT, getNow, getCurrentDate, parseDate, isBetweenDate */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79212);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66607);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71512);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14744);






var DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
var DATE_LONG_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
var DATE_PICKER_DATE_FORMAT = "dd/MM/yyyy";
var MOTOR_SUMMARY_DATE_FORMAT = "DD MMM YYYY";
var ORDER_LIST_DATE_SHORT_FORMAT = "DD MMM YYYY";
var ORDER_LIST_DATE_HOUR_MINUTE_FORMAT = "DD MMM YYYY HH:mm";
var ORDER_LIST_DATE_LONG_FORMAT = "DD MMM YYYY HH:mm:ss";
var getNow = function() {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
};
var getCurrentDate = function() {
    return getNow().startOf("day");
};
var parseDate = function(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_DATE_FORMAT;
    if (dayjs__WEBPACK_IMPORTED_MODULE_0___default().isDayjs(date)) {
        return date;
    }
    var newDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, format);
    if (newDate.isValid()) {
        return newDate;
    }
    throw new TypeError("Given date is invalid.");
};
var formatDateText = function(date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_constants_format__WEBPACK_IMPORTED_MODULE_4__/* .DATE_INPUT_TEXT_FORMAT */ .AV;
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, src_constants_format__WEBPACK_IMPORTED_MODULE_4__/* .DATE_INPUT_TEXT_FORMAT */ .AV);
    if (dayjsDate.isValid()) {
        return dayjsDate.format(dateFormat);
    }
    (0,_logger__WEBPACK_IMPORTED_MODULE_5__/* .logWarn */ .yN)("Given date is invalid.");
    return "";
};
var formatLocalizedDateText = function(date, dateFormat, language) {
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, dateFormat).locale(language);
    if (dayjsDate.isValid()) {
        return dayjsDate.format(dateFormat);
    }
    (0,_logger__WEBPACK_IMPORTED_MODULE_5__/* .logWarn */ .yN)("Given date is invalid.");
    return "";
};
var isBeforeDate = function(input) {
    var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentDate();
    try {
        return date.isAfter(parseDate(input).endOf("day"));
    } catch (e) {
        return false;
    }
};
var isAfterDate = function(input) {
    var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentDate();
    try {
        return date.isBefore(parseDate(input).startOf("day"));
    } catch (e) {
        return false;
    }
};
var isAfterDateTime = function(date) {
    try {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().isAfter(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date));
    } catch (error) {
        return false;
    }
};
var isBetweenDate = function(param) {
    var from = param.from, to = param.to, _date = param.date, date = _date === void 0 ? getCurrentDate() : _date, _edgeCase = param.edgeCase, edgeCase = _edgeCase === void 0 ? false : _edgeCase, _format = param.format, format = _format === void 0 ? DEFAULT_DATE_FORMAT : _format;
    try {
        dayjs.extend(isSameOrAfter);
        dayjs.extend(isSameOrBefore);
        dayjs.extend(isBetween);
        var parsedDate = parseDate(date);
        if (edgeCase) {
            return parsedDate.isSameOrAfter(dayjs(from, format).startOf("day")) && parsedDate.isSameOrBefore(dayjs(to, format).endOf("day"));
        }
        return parsedDate.isBetween(from, to);
    } catch (e) {
        return false;
    }
};
var isToday = function(currentDate) {
    return currentDate && getNow().isSame(currentDate, "day");
};
var isInDatePeriod = function(param) {
    var from = param.from, to = param.to, _date = param.date, date = _date === void 0 ? new Date() : _date, _edgeCase = param.edgeCase, edgeCase = _edgeCase === void 0 ? false : _edgeCase;
    try {
        var fromDate = new Date(from);
        var toDate = new Date(to);
        if (edgeCase) {
            return (!from || date >= fromDate) && (!to || date <= toDate);
        }
        return (!from || date > fromDate) && (!to || date < toDate);
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 65791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YY": function() { return /* binding */ maskPhoneNumber; },
/* harmony export */   "cY": function() { return /* binding */ maskBankAccountNumber; },
/* harmony export */   "hA": function() { return /* binding */ maskProfilePhoneNumber; },
/* harmony export */   "ln": function() { return /* binding */ maskCitizenId; },
/* harmony export */   "mX": function() { return /* binding */ maskPassportNo; },
/* harmony export */   "of": function() { return /* binding */ maskEmail; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var maskPhoneNumber = function(number) {
    var maskSymbol = "•";
    if (number) {
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("0", number)) {
            return "".concat(number.substring(0, 3), " ").concat(number.substring(3, 6).replace(/./g, maskSymbol), " ").concat(number.substring(6, 8));
        // .replace(/./g, maskSymbol)}${number.substring(8)}`;
        }
        // 66123456789 -> 661 2345 6789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("66", number)) {
            return "".concat(number.substring(0, 3), " ").concat(number.substring(3, 7).replace(/./g, maskSymbol), " ").concat(number.substring(7, 9));
        // .replace(/./g, maskSymbol)}${number.substring(9)}`;
        }
        // +66123456789 -> +661 2345 6789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("+66", number)) {
            return "".concat(number.substring(0, 4), " ").concat(number.substring(4, 8).replace(/./g, maskSymbol), " ").concat(number.substring(8, 10));
        // .replace(/./g, maskSymbol)}${number.substring(10)}`;
        }
        // default case
        return "".concat(number.substring(0, 4), " ").concat(number.substring(4, 8).replace(/./g, maskSymbol), " ").concat(number.substring(8, 10));
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
    }
    return "";
};
var maskEmail = function(email) {
    var maskSymbol = "•";
    if (email) {
        return "".concat(email.substring(0, 3), " ").concat(maskSymbol.repeat(email.substring(3).length));
    }
    return "";
};
var maskProfilePhoneNumber = function(number) {
    var maskSymbol = "*";
    var trimMobileNo = number === null || number === void 0 ? void 0 : number.replace(/\D/g, "");
    if (trimMobileNo) {
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("0", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 2)).concat(trimMobileNo.substring(2, 5).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(5, 8));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(8)}`;
        }
        // 66123456789 -> 66123456789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("66", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 2)).concat(trimMobileNo.substring(2, 6).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(6, 9));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(9)}`;
        }
        // +66123456789 -> +66123456789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("+66", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 4)).concat(trimMobileNo.substring(4, 7).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(7, 10));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(10)}`;
        }
        // default case
        return "".concat(trimMobileNo.substring(0, 3)).concat(trimMobileNo.substring(3, 7).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(7, 10));
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
    }
    return "";
};
var maskBankAccountNumber = function(accountNumber, maskSymbol) {
    var defaultMaskedString = "************";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixAccountNumber = accountNumber.slice(accountNumber.length - 4, accountNumber.length);
    return "".concat(prefixMaskedSymbol).concat(suffixAccountNumber);
};
var maskCitizenId = function(citizenId, maskSymbol) {
    var defaultMaskedString = "*********";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixCitizenId = citizenId.slice(citizenId.length - 4, citizenId.length);
    return "".concat(prefixMaskedSymbol).concat(suffixCitizenId);
};
var maskPassportNo = function(passportNo, maskSymbol) {
    var defaultMaskedString = "*****";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixCitizenId = "";
    if (passportNo.length <= 4) {
        suffixCitizenId = passportNo.slice(passportNo.length - 1, passportNo.length);
    } else {
        suffixCitizenId = passportNo.slice(passportNo.length - 4, passportNo.length);
    }
    return "".concat(prefixMaskedSymbol).concat(suffixCitizenId);
};


/***/ }),

/***/ 46536:
/***/ (function() {

/* (ignored) */

/***/ })

}]);